/**
 * AlcedisFramework methods
 */

var af = af || {};

// alcedis jquery extension
(function($) {
    $.fn.pop = function() {
        var top = this.get(-1);
        this.splice(this.length-1,1);
        return top;
    };

    $.fn.shift = function() {
        var bottom = this.get(0);
        this.splice(0,1);
        return bottom;
    };
})(jQuery);


/**
 * load javascript file
 *
 * @param   array fileList
 * @return  null
 */
af.loadJavascript = function(fileList) {
    for (i in fileList) {
        var file = fileList[i].split('?')[0];
        var tag = { src: fileList[i] };

        if (af.inArray(file, pool.loadedJS) === false && file.length > 0) {
            $.ajax({
                url: fileList[i],
                dataType: 'script',
                async: false,
                success: function () {
                    pool.loadedJS.push(file);
                    loadHandler.informLoad(tag);
                },
                error: function () {
                    loadHandler.loadError(tag);
                }
            });
        }
    }
};

/**
 * load stylesheet
 *
 * @param   array fileList
 * @return  null
 */
af.loadStylesheet = function(fileList) {
    for (i in fileList) {
        var file = fileList[i].split('?')[0];
        if (af.inArray(file, pool.loadedCSS) === false && file.length > 0) {
            $.ajax({
                url: file,
                dataType: 'text',
                async: false,
                type : 'post',
                success : function(data){
                    var $link = $('<link/>');
                    $('head').append($link);
                    $link.attr({
                        'type' : 'text/css',
                        'rel'  : 'stylesheet',
                        'href' : file
                    });
                    pool.loadedCSS.push(file);
                }
            });
        }
    }
};

/**
 * Build an url
 *
 * @param   object options
 * @return  string
 */
af.buildUrl = function (options) {
    options = $.extend({
        base: $('base').attr('href').replace(/\/*$/, ''),
        language: pool.language,
        accessId: pool.accessId + '-' + pool.windowId,
        application: pool.application,
        controller: pool.controller,
        action: 'index',
        params: ''
    }, options || {});

    if (typeof options.params === 'object') {
        var params = [];
        for (var i in options.params) {
            params.push(options.params[i]);
        }
        options.params = params;
    }

    if ($.isArray(options.params) === true) {
        options.params = options.params.join('/');
    }

    return af.toArray(options).join('/').replace(/\/*$/, '') + '/';
};


/**
 * Parses an url
 *
 * @param   string  url
 * @return  object
 */
af.parseURL = function (url) {
    var a =  document.createElement('a');
    a.href = url;

    return {
        source: url,
        protocol: a.protocol.replace(':',''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function(){
            var ret = {},
                seg = a.search.replace(/^\?/,'').split('&'),
                len = seg.length, i = 0, s;
            for (;i<len;i++) {
                if (!seg[i]) { continue; }
                s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
        hash: a.hash.replace('#',''),
        path: a.pathname.replace(/^([^\/])/,'/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
        segments: a.pathname.replace(/^\//,'').split('/')
    };
};

/**
 * show log messages
 */
af.log = (function () {
    "use strict";

    return new function () {

        /**
         * @var boolean
         */
        var onDevEnv = (function () {
            return (pool.hasOwnProperty("environment") === true && pool.environment === "dev");
        }());


        /**
         * show warn message
         *
         * @param {string} message
         * @return void
         */
        this.warn = function (message) {
            // show message only on dev env
            if (onDevEnv === true) {
                console.warn(message);
            }
        };


        /**
         * show log message
         *
         * @param {string} message
         * @return void
         */
        this.log = function (message) {
            // show message only on dev env
            if (onDevEnv === true) {
                console.log(message);
            }
        };


        /**
         * show error message
         *
         * @param {string} message
         * @return void
         */
        this.error = function (message) {
            // show message only on dev env
            if (onDevEnv === true) {
                console.error(message);
            }
        };


        /**
         * show info message
         *
         * @param {string} message
         * @return void
         */
        this.info = function (message) {
            // show message only on dev env
            if (onDevEnv === true) {
                console.info(message);
            }
        };
    }();
}());


/**
 * Converts an object to array
 *
 * @param   object object
 * @return  array
 */
af.toArray = function (object) {
    var array = [];

    for (var attribute in object) {
        array.push(object[attribute]);
    }

    return array;
};


/**
 * Clones an array
 *
 * @param   array array
 * @return  array
 */
af.cloneArray = function (array) {
    var replicant = [];

    for (var property in array) {
        replicant[property] = typeof (array[property]) == 'object'
            ? af.cloneArray(array[property])
            : array[property];
    }

    return replicant;
};


/**
 * Removes duplicate values from an array
 *
 * @param   array array
 * @return  array
 */
af.uniqueArray = function (array, strict) {
    strict = strict || false;

    if (array instanceof Array) {
        var sorter = {};
        var out    = [];

        for (var i = 0, j = array.length; i < j; i++){
            var item = strict ? array[i] + typeof array[i] : array[i];

            if ( ! sorter[item]) {
                out.push(array[i]);
                sorter[item] = true;
            }
        }
    }

    return out || array;
};

/**
 * Check for value in an Array
 *
 * @param  string  value
 * @param  array   array
 * @param  boolean returnIndex
 * @return mixed
 */
af.inArray = function (value, array, returnIndex) {
    returnIndex = returnIndex | false;

    if (typeof array !== 'object') {
        return false;
    }

    for (var i = 0, l = array.length; i < l; ++i) {
        if (array[i] === value) {
            return returnIndex ? i : true;
        }
    }

    return false;
};


/**
 * removes undefined elements from array
 *
 * @param  array   array
 * @return mixed
 */
af.cleanArray = function(array) {
    if (typeof array !== 'object') {
        return false;
    }
    var clean =  [];

    for (i in array) {
        if(array[i] !== undefined) {
            clean.push(array[i]);
        }
    }

    return clean;
};


/**
 * Tests if a variable is neither undefined nor null
 *
 * @param   mixed   variable
 * @return  array
 */
af.isEmpty = function (variable) {
    var get = variable !== undefined && variable !== null;

    if (get === false) {
        return true;
    }

    if (variable === false) {
        return false;
    }

    var length = variable.length;

    if (length > 0) {
        return false;
    } else if (typeof variable === 'string') {
        return true;
    }

    if (isNaN(variable) === false) {
        return false;
    }

    length = 0;

    // 'cause objects have no length
    for (var i = 0 in variable) {
        ++length;
    }

    return length === 0;
};


/**
 * sprintf in javascript
 *
 * @param   string   format
 * @param   mixed    arg1
 * @param   mixed    arg2
 * @param   mixed    arg3
 * @param   ...
 * @return  array
 */
af.sprintf = function (format) {
    var
        re = /%(?:(\d+)?(?:\.(\d+))?|\(([^)]+)\))([%bcdufosxX])/g,
        formats = {
            '%': function (val)    { return '%'; },
            'b': function (val)    { return  parseInt(val, 10).toString(2); },
            'c': function (val)    { return  String.fromCharCode(parseInt(val, 10)); },
            'd': function (val)    { return  parseInt(val, 10) ? parseInt(val, 10) : 0; },
            'u': function (val)    { return  Math.abs(val); },
            'f': function (val, p) { return  (p > -1) ? Math.round(parseFloat(val) * Math.pow(10, p)) / Math.pow(10, p): parseFloat(val); },
            'o': function (val)    { return  parseInt(val, 10).toString(8); },
            's': function (val)    { return  val; },
            'x': function (val)    { return  ('' + parseInt(val, 10).toString(16)).toLowerCase(); },
            'X': function (val)    { return  ('' + parseInt(val, 10).toString(16)).toUpperCase(); }
        };

        dispatch = function (data) {
            var idx = 0; // oh, the beauty of closures :D
            return function (match, w, p, lbl, fmt, off, str) {
                return formats[fmt](data[idx++], p);
            };
        }
    ;

    var argv = Array.apply(null, arguments).slice(1);
    return format.replace(re, dispatch(argv));
};


/**
 * Strips whitespaces from the beginning and end of a string
 *
 * @param   string   str
 * @return  string
 */
af.trim = function (str) {
    str = str.replace(/^\s+/, '');

    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }

    return str;
};


/**
 * Truncates a string and appends some chars
 *
 * @param   {String} str
 * @param   {Number} length
 * @param   {String} truncation
 * @return  string
 */
af.truncate = function (str, length, truncation) {
    length     = length     || 80;
    truncation = truncation || '...';
    str        = str        || '';

    if (str.length > length) {
        str = str.slice(0, length - truncation.length) + truncation;
    }

    return str;
};


/**
 * Open Dialog
 *
 * @param  object  options
 * @return void
 */
af.dialog = function (options) {
    options = $.extend({
        modal       : true,
        resizable   : false,
        cssClass    : 'default',
        size        : 'medium',
        title       : null,
        content     : null,
        url         : null,
        buttons     : {},
        showCancel  : false,
        onComplete	: function () {},
        open        : function () {},
        close       : function () { $(this).remove(); }
    }, options || {});

    var i18n          = pool.i18n.common;
    var self          = this;
    var buttons       = {};
    var btnClasses    = [];
    var standardSizes = {
        small:  [ 140, 200 ],
        medium: [ 340, 501 ],
        large:  [ 600, 700 ], // maxheight reached
        xl:     [ 600, 1000 ],
        custom: []
    };

    for (var name in options.buttons) {
        btnClasses.push(name);

        if (af.isEmpty(options.buttons[name]['label']) === false) {
            buttons[options.buttons[name]['label']] = options.buttons[name]['callback'];
        } else {
            if (af.isEmpty(i18n[name]) === false) {
                buttons[i18n[name]] = options.buttons[name]['callback'];
            } else {
                buttons[i18n.ok] = options.buttons[name]['callback'];
            }
        }
    }

    /**
     * set options.content on successful ajaxRequest
     * has to be public for access from $.ajax.success(self.setContent())
     *
     * @access  public
     * @param   string  content
     * @return  void
     */
    this.setContent = function (content) {
        options.content = content;
    };

    if (this.isEmpty(options.content) === true && this.isEmpty(options.url) === false) {
        $.ajax({
            type    : 'GET',
            url     : options.url,
            dataType: 'html',
            success : function (response) {
                self.setContent(response);
            },
            error   : console.error,
            complete: function () {
                $dialog.append(options.content);
                options.onComplete.call($dialog);
            }
        });
    }

    if (options.size instanceof Array) {
        if (options.size.length == 2 && options.size[0] >= 140 && options.size[1] >= 200) {
            standardSizes.custom = [options.size[0], options.size[1]];
            options.size    = 'custom';
        } else {
            options.size    = 'medium';
        }
    }

    if (options.showCancel === true && af.isEmpty(buttons.cancel) === true) {
        var tmp = buttons;
        buttons = {};
        buttons[i18n.cancel] = function () {
            $(this).dialog('destroy').remove();
        };

        for (var label in tmp) {
            buttons[label] = tmp[label];
        }

        btnClasses.unshift('cancel'); // add Cancel-Button and Class
    }


    $dialog = $('<div>')
        .addClass('afDialog-' + options.cssClass)
        .html(options.content)
        .dialog({
            bgiframe: true,
            modal: options.modal,
            resizable: options.resizable,
            height: standardSizes[options.size][0] || standardSizes.medium[0],
            width: standardSizes[options.size][1] || standardSizes.medium[1],
            title: options.title,
            buttons: buttons,
            open: options.open,
            close: options.close
        });

    buttons = {};
    $('button.ui-corner-all').each(function (i) {
        $(this).attr('class', btnClasses[i]).afButton();
    });
};


/**
 * replace %(var)type in yaml files,
 * replacement as object with {var: content}
 *
 * @param   string  string
 * @param   object  args
 * @param   boolean g
 * @return  mixed
 */
af.match = function (string, args, g) {
    if (args instanceof Object) {
        for (var arg in args) {
            var i18nVar     = '%(' + arg + ')';
            var typeIndex   = string.indexOf(i18nVar);

            if (typeIndex === -1) {
                continue;
            }

            var type   = string.substr(typeIndex + i18nVar.length, 1);
            var format = '%' + type;

            i18nVar += type;

            if (g === true) {
                var regEx  = new RegExp('%\\('+ arg +'\\)[%bcdufosxX]', 'g');
            }

            string = string.replace(regEx || i18nVar, af.sprintf(format, args[arg]));
        }

        return string;
    }

    return string;
};


af.browser = af.browser || {};

/**
 * @return boolean
 */
af.browser.hasFileDroppingFeature = function () {
    return typeof File !== undefined && (typeof FormData !== undefined || (typeof FileReader !== undefined));
};

af.browser.isEventSupported = function (eventName, element) {
    element = element || document.createElement("div");
    eventName   = "on" + eventName;

    var isSupported = eventName in element;

    if (!isSupported) {
        if (!element.setAttribute) {
            element = document.createElement("div");
        }

        if (element.setAttribute && element.removeAttribute) {
            element.setAttribute(eventName, "");

            isSupported = typeof element[eventName] == "function";

            if (typeof element[eventName] != "undefined") {
                element[eventName] = undefined;
            }

            element.removeAttribute(eventName);
        }
    }

    element = null;

    return isSupported;
};

/**
 * @return object
 */
af.browser.getSize = function () {
    var size = {
        x: null,
        y: null
    };

    if (navigator.appName.indexOf('Explorer') != -1) {
        size.x = document.documentElement.clientWidth;
        size.y = document.documentElement.clientHeight;
    } else {
        size.x = window.innerWidth;
        size.y = window.innerHeight;
    }

    return size;
};


/**
 * capitalize
 *
 * @param   string  str
 * @return  string
 */
af.capitalize = function (str) {
    var
        len     = str.length,
        tmpChar = str.substring(0, 1).toUpperCase(),
        tmpStr  = str.substring(1, len).toLowerCase()
    ;

    return tmpChar + tmpStr;
};



/**
 * Escapes HTML the jQuery-way
 *
 * this REMOVES all html-tags actually!!! useless?
 *
 * @param string string
 * @return string
 */
af.escapeHtml = function (string) {
	return string.replace(/<\/?[^>]+>/gi, '');
};


/**
 * espace html AND keep newlines rather slow
 */
af.escapeHtmlAndKeepNewlines = function(string) {
    return $('<span/>').text(string.replace(/\n/gi, '\\n')).html().replace(/\\n/g, '<br/>');
};

/**
 * camelCase
 *
 * @param   string  str string seperator
 * @return  string
 */
af.camelcase = function (str, seperator) {
    seperator = seperator || '_';

	var
	    result    = '',
	    parts     = str.split(seperator)
    ;

	for (i in parts) {
		if (i > 0){
	        result += this.capitalize(parts[i]);
        } else {
            result += parts[i];
        }
	}

    return result;
};


/**
 * unCamelCase the given string
 *
 * @param    string
 * @param    separator
 * @returns {string}
 */
af.unCamelCase = function (string, separator) {
    separator = separator || '_';

    return string.replace(/([A-Z])/g, separator + '$1', string).toLowerCase();
};


/**
 * upper case first character
 *
 * @param str
 * @returns {string}
 */
af.ucFirst = function (str) {
    str += '';

    var f = str.charAt(0).toUpperCase();

    return f + str.substr(1);
}


/**
 * generated uniqueIds storage
 *
 * this is used to globally ensure that the generated random is unique
 */
af._alreadyGeneratedIds = [];


/**
 * uniqueId
 *
 * @param  attribute
 * @param  $scope
 *
 * @return string
 */
af.uniqueId = function (attribute, $scope, check) {
    var guid = function () {
        var rand = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };

        var uidCandidate;
        // check if the generated random value already occurred, if yes, retry
        do {
            uidCandidate = rand() + '-' + rand();
        } while ($.inArray(uidCandidate, af._alreadyGeneratedIds) !== -1);
        af._alreadyGeneratedIds.push(uidCandidate);
        return uidCandidate;
    };

    // get a unique random id
    var id = guid();

    if (check === true) {
        // check if an attribute with this id exist, if yes retry...
        if ($('[' + attribute + '*=' + id + ']', $scope).length > 0) {
            return af.uniqueId(attribute, $scope, true);
        }
    }

    return id;
};


/**
 * Removes array content
 * e.g.
 *
 * Remove the second item from the array
 *      array.remove(1);
 * Remove the second-to-last item from the array
 *      array.remove(-2);
 * Remove the second and third items from the array
 *      array.remove(1,2);
 * Remove the last and second-to-last items from the array
 *      array.remove(-2,-1);
 *
 */
af.arrayRemove = function (array, from, to) {
    var rest = array.slice((to || from) + 1 || array.length);
    array.length = from < 0 ? array.length + from : from;

    return array.push.apply(array, rest);
};


af.utils = af.utils || {};

af.utils.loopRecursively = function (v, cb) {
    if (v instanceof Array) {
        v.forEach(function (val, i) {
            v[i] = af.utils.loopRecursively(v[i], cb);
        });
    } else if (v instanceof Object) {
        for (var i in v) {
            if (v.hasOwnProperty(i)) {
                v[i] = af.utils.loopRecursively(v[i], cb);
            }
        }
    } else {
        v = cb(v);
    }

    return v;
};


af.string = af.string || {};


/**
 * Returns the filename component of the path
 *
 * @access  public
 * @param   {string}    path
 * @param   {string}    suffix
 * @return  {string}
 */
af.string.basename = function (path, suffix) {
    var basename = path.replace(/^.*[\/\\]/g, '');

    if (typeof(suffix) === 'string' && basename.substr(basename.length - suffix.length) === suffix) {
        basename = basename.substr(0, basename.length - suffix.length);
    }

    return basename;
};


/**
 * afString::contains adaption
 */
af.string.contains = function(string, contains) {
    return af.isEmpty(string) === false && string.indexOf(contains) !== -1;
};

/**
 * afString::startsWith adaption
 */
af.string.startsWith = function(string, start) {
    return af.isEmpty(string) === false && string.indexOf(start) === 0;
};


/**
 * afString::endsWith adaption
 */
af.string.endsWith = function(string, end) {
    return af.isEmpty(string) === false && string.slice(-1 * end.length) === end;
};


af.cookie = af.cookie || {};

/**
 * write a value in a cookie
 *
 * @access  public
 * @param   {string}    name
 * @param   {string}    value
 * @param   {string}    path    [optional = /]
 * @param   {number}    expire  [optional = 20 years]
 * @param   {boolean}   secure  [optional = true]
 * @return  void
 */
af.cookie.write = function (name, value, path, expire, secure) {
    // Set cookies secure by default (only transfer on https requests)
    secure = secure || true;

    if (name === undefined || value === undefined) {
        throw 'name and value must given.';
    }
    // use encodeURIComponent to avoid FF utf-8-cookie bug
    var cookieString = name + '=' + encodeURIComponent(value) + '; ';

    if (expire !== 0) {
        if (expire === undefined) {
            expire = 20 * 365 * 24 * 60 * 60 * 1000;
        }
        expire = (new Date((new Date).getTime() + expire)).toGMTString();

        cookieString += 'expires=' + expire + '; ';
    }

    cookieString += 'path=' + (((path || '').replace(/\/$/, '') + '/') || '/');

    // Set secure flag. Cookie will only be sent on https connections.
    if (secure === true) {
        cookieString += '; secure';
    }

    document.cookie = cookieString;
};


/**
 * read a value from a cookie
 *
 * @access  public
 * @param   {string}    name
 * @return  {string}
 */
af.cookie.read = function (name) {
    var cookies = document.cookie.split('; ');

    for (var i in cookies) {
        var cookie = cookies[i].split('=');
        if (cookie[0] === name) {
            return decodeURIComponent(cookie[1]);// use decodeURIComponent to avoid FF utf-8-cookie bug
        }
    }

    return '';
};


af.string = af.string || {};

/**
 * search a string and highlight
 *
 * @param   {string}    text
 * @param   {string}    search
 * @return  {string}
 */
af.string.highlight = function (text, search, addClass) {
    if (search === undefined) {
        return text;
    }

    addClass = addClass === undefined ? '' : addClass;

    var regex = new RegExp(
        '(<[^>]*>)|(' +
            search.replace(/([-.*+?^${}()|[\]\/\\])/g, "\\$1") +
        ')',
        'ig'
    );

    return text.replace(regex, function (search, b, c, pos, e) {
        if (search.charAt(0) == '<') {
            return search;
        }

        var
            before = text.substring(0, pos).split('>').pop().indexOf('&'),
            after  = text.substring(pos + search.length).split('<').shift().indexOf(';')
        ;
        //TODO: completely make sure, that no invalid html reaches here!!!
        if (before > -1 && after > -1 && false) {
            return search;
        } else {
            return '<span class="highlight ' + addClass + '">' + c + '</span>';
        }
    });
};

/**
 * is filled
 *
 * @param   {string}    string
 * @return  {boolean}
 */
af.string.isFilled = function (string) {
    return string !== '';
};

/**
 * is empty
 *
 * @param   {string}    string
 * @return  {boolean}
 */
af.string.isEmpty = function (string) {
    return string === '';
};

/**
 * date object
 */
af.date = af.date || {};

/**
 * get separator for date
 *
 * @access  public
 * @return  string
 */
af.date.getSeparator = function () {
    var separator = '';

    var arrSeparator = pool.dateFormat.match(/[^\w]/);
    if (arrSeparator !== null) {
        separator = arrSeparator[0];
    }

    return separator;
};

/**
 * caching date string
 *
 * @access  public
 * @var     object
 */
af.date.sortCache = af.date.sortCache || {};

/**
 * this is a helper function specially for data tables
 *
 * @access  public
 * @param   string  format
 * @return  boolean
 */
af.date.sort = function (format) {
    var separator = af.date.getSeparator();

    format = format.split(separator);

    /**
     * convert a date string to a sortable date string
     *
     * @access  private
     * @param   string  date
     * @return  object
     */
    var toNumeric = function (date) {
        date = date.split(separator);

        var
            length = format.length,
            iso    = {},
            label  = ''
        ;

        while (--length > -1) {
            iso[format[length]] = date[length];
        }

        // time
        if (iso.yy !== undefined && iso.yy.length > 4) {
            var yearTime = iso.yy.split(' ');

            if (yearTime[1] === undefined) {
                yearTime[0] = iso.yy.substr(0, 4);
                yearTime[1] = '';
            }

            label = '' + yearTime[0] + iso.mm + iso.dd + yearTime[1].replace(':', '');
        } else {
            label = '' + iso.yy + iso.mm + iso.dd;
        }

        return label;
    };

    return {
        asc: function (a, b) {
            a = af.date.sortCache[a] = af.date.sortCache[a] || toNumeric(a);
            b = af.date.sortCache[b] = af.date.sortCache[b] || toNumeric(b);

            return a < b ? -1 : (a > b ? 1 : 0);
        },
        desc: function (a, b) {
            a = af.date.sortCache[a] = af.date.sortCache[a] || toNumeric(a);
            b = af.date.sortCache[b] = af.date.sortCache[b] || toNumeric(b);

            return a < b ? 1 : (a > b ? -1 : 0);
        }
    };
};

/**
 * compare methods for different data types
 */
af.compare = af.compare || {};

/**
 * compare dates
 */
af.compare.date = {
    'asc': af.date.sort(pool.dateFormat).asc,
    'desc': af.date.sort(pool.dateFormat).desc
};

/**
 * compare strings
 */
af.compare.string = {
    'asc': function (a, b) {
        var
            x = (a + '').toLowerCase(),
            y = (b + '').toLowerCase()
        ;

        return x < y ? -1 : (x > y ? 1 : 0);
    },
    'desc': function (a, b) {
        var
            x = (a + '').toLowerCase(),
            y = (b + '').toLowerCase()
        ;

        return x < y ? 1 : (x > y ? -1 : 0);
    }
};

/**
 * Compare/sort strings - the pretty way (1,2,3,4,5,6,7,8,9,10,11 instead 1,10,11,2,3,4,5,6,7,8,9)
 */
af.compare.alphanumeric = {
    'asc': function (a, b) {
        var
            x           = (a + '').toLowerCase(),
            y           = (b + '').toLowerCase(),
            stringDiff  = af.compareAlphanumeric(x, y)
        ;

        return stringDiff < 0 ? -1 : (stringDiff > 0 ? 1 : 0);
    },
    'desc': function (a, b) {
        var
            x           = (a + '').toLowerCase(),
            y           = (b + '').toLowerCase(),
            stringDiff  = af.compareAlphanumeric(x, y)
        ;

        return stringDiff < 0 ? 1 : (stringDiff > 0 ? -1 : 0);
    }
};

/**
 * compare numerics
 */
af.compare.numeric = {
    'asc': function (a, b) {
        a = (a + '').replace(pool.floatFormat, '.');
        b = (b + '').replace(pool.floatFormat, '.');
        var floatA = parseFloat(a);
        var floatB = parseFloat(b);

        return (isNaN(floatA) === true || isNaN(floatB) === true)
            ? af.compare.string.asc(a, b)
            : floatA - floatB;
    },
    'desc': function (a, b) {
        a = (a + '').replace(pool.floatFormat, '.');
        b = (b + '').replace(pool.floatFormat, '.');
        var floatA = parseFloat(a);
        var floatB = parseFloat(b);

        return (isNaN(floatA) === true || isNaN(floatB) === true)
            ? af.compare.string.desc(a, b)
            : floatB - floatA;
    }
};

/**
 * compare datetimes
 */
af.compare.datetime = af.compare.date;

/**
 * compare checkbox (actually it's label)
 */
af.compare.checkbox = af.compare.string;


af.int = af.int || {};

/**
 * random
 *
 * @access  public
 * @param   {integer}   min
 * @param   {integer}   max
 * @param   {integer}
 */
af.int.random = function (min, max) {
    if (min > max) {
        return -1;
    }

    if (min === max) {
        return min;
    }

    return min + parseInt(Math.random() * (max - min + 1));
};

/**
 * dyn addStylesheet
 *
 * @param 	{string}	$file
 * @param 	{function}	$callback
 * @returns	void
 */
af.addStylesheet = function($file, $callback) {
	var $head    = $('head');
	var filePath = pool.afPath + 'media/css/' + $file;

	// important for IE8: set attributes to link element after it was appended
	$('<link />').appendTo($head).attr({
	        href: filePath,
	        rel:  'stylesheet',
	        type: 'text/css'
	});

	if (typeof $callback === 'function') {
		$callback();
	}
};

/**
 * Break up a string and compare it the corect way (respecting number-values in string)
 *
 * @param   {string}    sourceString
 * @param   {string}    targetString
 * @returns {integer}
 */
af.compareAlphanumeric = function (sourceString, targetString) {
    /**
     * Breaks up a string in a array consisting of string- and number-parts.
     * Example:
     * 'Just my 2 cents 4 today' => ['Just my ', '2', ' cents ', '4', ' today']
     *
     * @param   {String}    currentString
     * @returns {Array}
     */
    function chunkify(currentString) {
        var
            characters              = [],
            stringPosition          = 0,
            arrayIndex              = -1,
            lastCharacterWasNumber  = 0,
            decimalPointCode        = 46,
            asciiCode,
            currentCharacter
        ;

        if (pool.floatFormat.length > 0) {
            decimalPointCode = pool.floatFormat.charCodeAt(0);
        }

        while (asciiCode = (currentCharacter = currentString.charAt(stringPosition++)).charCodeAt(0)) {
            var isNumber = false;
            if (asciiCode == decimalPointCode || (asciiCode >= 48 && asciiCode <= 57)) {
                isNumber = true;
            }

            if (isNumber !== lastCharacterWasNumber) {
                // Initialize the next array-dataset as string
                characters[++arrayIndex] = "";
                lastCharacterWasNumber   = isNumber;
            }

            // Append current character to current array-dataset
            characters[arrayIndex] += currentCharacter;
        }

        return characters;
    }

    var sourceChunks = chunkify(sourceString);
    var targetChunks = chunkify(targetString);

    for (chunkIndex = 0; sourceChunks[chunkIndex] && targetChunks[chunkIndex]; chunkIndex++) {
        if (sourceChunks[chunkIndex] !== targetChunks[chunkIndex]) {
            // Try to convert current chunks to numbers (NaN on failure, but that's OK here)
            var
                sourceChunkNumber = Number(sourceChunks[chunkIndex]),
                targetChunkNumber = Number(targetChunks[chunkIndex])
            ;

            // If chunks are numbers, substract them. Otherwise just compare the strings.
            if (sourceChunkNumber == sourceChunks[chunkIndex] && targetChunkNumber == targetChunks[chunkIndex]) {
                return sourceChunkNumber - targetChunkNumber;
            } else {
                return (sourceChunks[chunkIndex] > targetChunks[chunkIndex]) ? 1 : -1;
            }
        }
    }

    // If no other differences were found, just substract the length of the chunk-arrays
    return sourceChunks.length - targetChunks.length;
};


/**
 * Check, if local storage is usable and either return Storage object when usable, or false if not
 *
 * @param   {string} [type] which browser storage to return: local (persistent) or session (emptied on browser close)
 * @returns {boolean|Storage}
 */
af.getBrowserStorage = function (type) {
    var storage = false;
    type        = type || 'local';

    // Simply check, if we can set and read a value to/from local storage. This check will also fail, when storage is
    // full, so we do not need a separate check for that.
    try {
        var storageForCheck;
        var uid = Date.now().toString(); // Key and value must be s string in local storage

        // We can request the local storage (persistent storage) or the session storage (emptied when browser is closed)
        if (type === 'local') {
            storageForCheck = window.localStorage;
        } else {
            storageForCheck = window.sessionStorage;
        }

        storageForCheck.setItem(uid, uid);

        // When item could be set and now can be read, storage is available and usable
        if (storageForCheck.getItem(uid) === uid) {
            storage = storageForCheck;
        }

        storageForCheck.removeItem(uid);
    } catch (exception) {
        // Local storage isn't usable (either not available or full)
    }

    return storage;
};


af.string.html_entity_decode = function(string, quote_style) {
   // fix: return nothing on empty or invalid string (null, false, undefined)
   if (string === null || string === undefined || string.length === 0) {
      return string;
   }
    // Convert all HTML entities to their applicable characters
    //
    // version: 1109.2015
    // discuss at: http://phpjs.org/functions/html_entity_decode    // +   original by: john (http://www.jd-tech.net)
    // +      input by: ger
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman    // +   improved by: marc andreu
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Ratheous
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Nick Kolosov (http://sammy.ru)    // +   bugfixed by: Fox
    // -    depends on: get_html_translation_table
    // *     example 1: html_entity_decode('Kevin &amp; van Zonneveld');
    // *     returns 1: 'Kevin & van Zonneveld'
    // *     example 2: html_entity_decode('&amp;lt;');    // *     returns 2: '&lt;'
    var hash_map = {},
        symbol = '',
        tmp_str = '',
        entity = '';    tmp_str = string.toString();

    if (false === (hash_map = this.get_html_translation_table('HTML_ENTITIES', quote_style))) {
        return false;
    }
    // fix &amp; problem
    // http://phpjs.org/functions/get_html_translation_table:416#comment_97660
    delete(hash_map['&']);
    hash_map['&'] = '&amp;';
    for (symbol in hash_map) {
        entity = hash_map[symbol];
        tmp_str = tmp_str.split(entity).join(symbol);
    }    tmp_str = tmp_str.split('&#039;').join("'");

    return tmp_str;
};


af.string.get_html_translation_table = function(table, quote_style) {
    // Returns the internal translation table used by htmlspecialchars and htmlentities
    //
    // version: 1109.2015
    // discuss at: http://phpjs.org/functions/get_html_translation_table    // +   original by: Philip Peterson
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: noname
    // +   bugfixed by: Alex
    // +   bugfixed by: Marco    // +   bugfixed by: madipta
    // +   improved by: KELAN
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Frank Forte    // +   bugfixed by: T.Wild
    // +      input by: Ratheous
    // %          note: It has been decided that we're not going to add global
    // %          note: dependencies to php.js, meaning the constants are not
    // %          note: real constants, but strings instead. Integers are also supported if someone    // %          note: chooses to create the constants themselves.
    // *     example 1: get_html_translation_table('HTML_SPECIALCHARS');
    // *     returns 1: {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}
    var entities = {},
        hash_map = {};
    var constMappingTable = {},
        constMappingQuoteStyle = {};
    var useTable = {},
        useQuoteStyle = {};
    // Translate arguments
    constMappingTable[0] = 'HTML_SPECIALCHARS';
    constMappingTable[1] = 'HTML_ENTITIES';
    constMappingQuoteStyle[0] = 'ENT_NOQUOTES';    constMappingQuoteStyle[2] = 'ENT_COMPAT';
    constMappingQuoteStyle[3] = 'ENT_QUOTES';

    useTable = !isNaN(table) ? constMappingTable[table] : table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
    useQuoteStyle = !isNaN(quote_style) ? constMappingQuoteStyle[quote_style] : quote_style ? quote_style.toUpperCase() : 'ENT_COMPAT';
    if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
        throw new Error("Table: " + useTable + ' not supported');
        // return false;
    }
    entities['38'] = '&amp;';
    if (useTable === 'HTML_ENTITIES') {
        entities['160'] = '&nbsp;';
        entities['161'] = '&iexcl;';        entities['162'] = '&cent;';
        entities['163'] = '&pound;';
        entities['164'] = '&curren;';
        entities['165'] = '&yen;';
        entities['166'] = '&brvbar;';        entities['167'] = '&sect;';
        entities['168'] = '&uml;';
        entities['169'] = '&copy;';
        entities['170'] = '&ordf;';
        entities['171'] = '&laquo;';        entities['172'] = '&not;';
        entities['173'] = '&shy;';
        entities['174'] = '&reg;';
        entities['175'] = '&macr;';
        entities['176'] = '&deg;';        entities['177'] = '&plusmn;';
        entities['178'] = '&sup2;';
        entities['179'] = '&sup3;';
        entities['180'] = '&acute;';
        entities['181'] = '&micro;';        entities['182'] = '&para;';
        entities['183'] = '&middot;';
        entities['184'] = '&cedil;';
        entities['185'] = '&sup1;';
        entities['186'] = '&ordm;';        entities['187'] = '&raquo;';
        entities['188'] = '&frac14;';
        entities['189'] = '&frac12;';
        entities['190'] = '&frac34;';
        entities['191'] = '&iquest;';        entities['192'] = '&Agrave;';
        entities['193'] = '&Aacute;';
        entities['194'] = '&Acirc;';
        entities['195'] = '&Atilde;';
        entities['196'] = '&Auml;';        entities['197'] = '&Aring;';
        entities['198'] = '&AElig;';
        entities['199'] = '&Ccedil;';
        entities['200'] = '&Egrave;';
        entities['201'] = '&Eacute;';        entities['202'] = '&Ecirc;';
        entities['203'] = '&Euml;';
        entities['204'] = '&Igrave;';
        entities['205'] = '&Iacute;';
        entities['206'] = '&Icirc;';        entities['207'] = '&Iuml;';
        entities['208'] = '&ETH;';
        entities['209'] = '&Ntilde;';
        entities['210'] = '&Ograve;';
        entities['211'] = '&Oacute;';        entities['212'] = '&Ocirc;';
        entities['213'] = '&Otilde;';
        entities['214'] = '&Ouml;';
        entities['215'] = '&times;';
        entities['216'] = '&Oslash;';        entities['217'] = '&Ugrave;';
        entities['218'] = '&Uacute;';
        entities['219'] = '&Ucirc;';
        entities['220'] = '&Uuml;';
        entities['221'] = '&Yacute;';        entities['222'] = '&THORN;';
        entities['223'] = '&szlig;';
        entities['224'] = '&agrave;';
        entities['225'] = '&aacute;';
        entities['226'] = '&acirc;';        entities['227'] = '&atilde;';
        entities['228'] = '&auml;';
        entities['229'] = '&aring;';
        entities['230'] = '&aelig;';
        entities['231'] = '&ccedil;';        entities['232'] = '&egrave;';
        entities['233'] = '&eacute;';
        entities['234'] = '&ecirc;';
        entities['235'] = '&euml;';
        entities['236'] = '&igrave;';        entities['237'] = '&iacute;';
        entities['238'] = '&icirc;';
        entities['239'] = '&iuml;';
        entities['240'] = '&eth;';
        entities['241'] = '&ntilde;';        entities['242'] = '&ograve;';
        entities['243'] = '&oacute;';
        entities['244'] = '&ocirc;';
        entities['245'] = '&otilde;';
        entities['246'] = '&ouml;';        entities['247'] = '&divide;';
        entities['248'] = '&oslash;';
        entities['249'] = '&ugrave;';
        entities['250'] = '&uacute;';
        entities['251'] = '&ucirc;';        entities['252'] = '&uuml;';
        entities['253'] = '&yacute;';
        entities['254'] = '&thorn;';
        entities['255'] = '&yuml;';
    }
    if (useQuoteStyle !== 'ENT_NOQUOTES') {
        entities['34'] = '&quot;';
    }
    if (useQuoteStyle === 'ENT_QUOTES') {
        entities['39'] = '&#39;';
    }
    entities['60'] = '&lt;';
    entities['62'] = '&gt;';

    // ascii decimals to real symbols
    for (var decimal in entities) {
        if (entities.hasOwnProperty(decimal)) {
            hash_map[String.fromCharCode(decimal)] = entities[decimal];
        }
    }

    return hash_map;
};

af.form = af.form || {};

af.form.toObject = function($form) {
    $form = $form || $('form');

    formData = {};
    $form.find(':input:not(.external)').each(function (i, el) {
        var $el   = $(el);
        var type  = $el.attr('type');
        var name  = $el.attr('name');
        var value = $el.attr('value');

        if (name !== undefined) {
            if (type === 'checkbox' && $el.is(':checked') === false) {
                formData[name] = '';
            } else if (type === 'radio') {
                if ($el.is(':checked')) {
                    formData[name] = formData[name] = value;
                } else {
                    formData[name] = formData[name] || '';
                }
            } else {
                formData[name] = value;
            }
        }
    });

    return formData;
};

/**
* af timer events (overwrite global interval and timeout function to be more accurate)
*
* @type {{}}
*/
af.accurateTimer = af.accurateTimer || {};
af.time = af.time || {};

af.navigationKeyMapping = {
    tab:         9,
    enter:       13,
    esc:         27,
    space:       32,
    pageUp:      33,
    pageDown:    34,
    end:         35,
    pos1:        36,
    left:        37,
    up:          38,
    right:       39,
    down:        40,
    s:           83,
    t:           84,
    numpadPlus:  107,
    numpadMinus: 109,
    f1:          112,
};

(function () {
    /**
     * the real counter (check function has multiple fallback to break timeout to avoid event overlay)
     *
     * @param fn
     * @param delay
     * @param repeat
     * @returns {*}
     * @private
     */
    var _internalTimer = function (fn, delay, repeat) {
        /**
         * object handler
         *
         * @type {*}
         */
        var self = this;

        /**
         * interval flag
         *
         * @type {*|boolean}
         */
        this.repeat = repeat || false;


        /**
         * start date
         * @type {Date}
         */
        this.start = new Date;

        /**
         * stop timestamp
         *
         * @type {number}
         */
        this.end = self.start.getTime() + delay;

        /**
         * original timer event index
         *
         * @type {number}
         */
        this.timer = 0;

        /**
         * actual delay
         *
         * @type {*}
         */
        this.delay = delay;

        /**
         * callback function
         *
         * @type {*}
         */
        this.callback = fn;

        /**
         * recursive timeout function
         */
        this.check = function () {
            self.timer = window.setTimeout(function () {
                var now = new Date;
                if (self.end == false) {
                    self.stop();
                    return;
                }

                if (now.getTime() >= self.end) {
                    if (self.repeat === true && self.end !== false) {
                        self.end = now.getTime() + self.delay;
                        self.check();
                    }
                    self.callback();
                } else if (self.end !== false) {
                    self.check();
                }
            }, 100);
        };

        /**
         * stop event
         */
        this.stop = function () {
            window.clearTimeout(self.timer);
            self.end = false;
        };

        this.check();

        return this;
    };

    /**
     * timeout function
     *
     * @param fn
     * @param delay
     * @returns {_internalTimer}
     */
    af.accurateTimer.timeout = function (fn, delay) {
        return new _internalTimer(fn, delay, false);
    };

    /**
     * interval function
     *
     * @param fn
     * @param delay
     * @returns {_internalTimer}
     */
    af.accurateTimer.interval = function (fn, delay) {
        return new _internalTimer(fn, delay, true);
    };


    /**
     * overwritten setTimeout
     *
     * @param fn
     * @param delay
     * @returns {Number|_internalTimer}
     */
    af.time.setTimeout = function (fn, delay) {
        return af.accurateTimer.timeout(fn, delay);
    };

    /**
     * overwritten setInterval
     *
     * @param fn
     * @param delay
     * @returns {*}
     */
    af.time.setInterval = function (fn, delay) {
        return af.accurateTimer.interval(fn, delay);
    };

    /**
     * overwritten clearTimeout
     *
     * @param timer
     */
    af.time.clearTimeout = function (timer) {
        if (typeof timer === 'object' && typeof timer.stop === 'function') {
            timer.stop();
        } else {
            window.clearTimeout();
        }
    };

    /**
     * overwritten clearInterval
     *
     * @param timer
     */
    af.time.clearInterval = function (timer) {
        if (typeof timer === 'object' && typeof timer.stop === 'function') {
            timer.stop();
        } else {
            window.clearInterval(timer);
        }
    };


    /**
     * returns global time in milliseconds since 01/01/1970
     *
     * @returns {number}
     */
    af.time.getTime = function() {
        var d = new Date();
        return d.getTime();
    };
}) ();
